import { Tabs } from "antd"
import React from "react"
import { useLocation, useNavigate } from "react-router-dom"

import { RoutesPaths } from "../../../../constants/routes.ts"
import { useAppSelector } from "../../../../hooks/use-app-selector.ts"
import {
  selectActiveBranch,
  selectActiveBranchId,
  selectCompanyIsMultiBranch
} from "../../../Branches/redux/branches.slice.ts"

// Configurations, Required Information and Templates are grouped under one
// "Company Defaults" section — the authoritative, reusable baseline every
// branch either inherits from or explicitly overrides — without becoming a
// second, competing settings page: each subtab still IS the pre-existing
// page/route/redux-slice/API endpoint it always was, unchanged. This strip
// is purely a navigation grouping on top of them.
const SUBTABS = [
  { key: RoutesPaths.settings.configuration, label: "Configurations" },
  { key: RoutesPaths.settings.formFieldRequirements, label: "Required Information" },
  { key: RoutesPaths.settings.templates, label: "Templates" }
]

export function CompanyDefaultsSubTabs() {
  const navigate = useNavigate()
  const pathname = useLocation()?.pathname
  const isMultiBranch = useAppSelector(selectCompanyIsMultiBranch)
  const activeBranchId = useAppSelector(selectActiveBranchId)
  const activeBranchName = useAppSelector(selectActiveBranch)?.name
  // The tab stays named "Company Defaults" everywhere — only the scope line
  // underneath changes — so a branch workspace never reads as a second,
  // HQ-only settings surface the way the "Branch & System" rename does for
  // Company & System.
  const isBranchScope = isMultiBranch && !!activeBranchId

  const activeKey = SUBTABS.filter(
    ({ key }) => pathname === key || pathname?.startsWith(`${key}/`)
  ).reduce((longest, item) => (item.key.length > longest.length ? item.key : longest), "")

  return (
    <div className="mb-3">
      <div className="text-xs uppercase tracking-wide text-gray-400 mb-1">
        {isBranchScope
          ? `Company Defaults · Defaults for ${activeBranchName ?? "this branch"}`
          : "Company Defaults"}
      </div>
      <Tabs
        activeKey={activeKey || SUBTABS[0].key}
        items={SUBTABS}
        onChange={navigate}
        className="[&_.ant-tabs-nav]:mb-0 [&_.ant-tabs-tab]:py-1"
      />
    </div>
  )
}
